export default __webpack_public_path__ + "static/LandingPageHeader-91dc1b149911ff2b7888e1e0ce848ba8.svg";